import { useEffect, useState } from 'react';
import { Progress } from '@/components/ui/progress';
import * as Icons from 'lucide-react';

/**
 * Upload busy banner with a loading bar.
 * Advances while `active`, holds near the end until the request finishes, then fills.
 */
export function DocumentUploadProgress({ active, label = 'Uploading & scanning document…' }) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!active) {
      setValue(0);
      return undefined;
    }
    setValue(8);
    const timer = setInterval(() => {
      setValue((v) => {
        if (v >= 92) return v;
        if (v < 40) return v + 6;
        if (v < 70) return v + 3;
        return v + 1;
      });
    }, 280);
    return () => clearInterval(timer);
  }, [active]);

  if (!active) return null;

  return (
    <div
      className="rounded-lg border bg-muted/40 px-4 py-3 space-y-2"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex items-center gap-2 text-sm font-medium">
        <Icons.Loader2 className="h-4 w-4 animate-spin text-primary shrink-0" />
        <span>{label}</span>
        <span className="ml-auto font-mono text-xs text-muted-foreground">{Math.min(99, value)}%</span>
      </div>
      <Progress value={value} className="h-2.5" />
      <p className="text-xs text-muted-foreground">
        Please wait — other uploads are locked until this finishes.
      </p>
    </div>
  );
}
